import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import HomeScreen from "./screens/HomeScreen";
import LoginScreen from "./screens/LoginScreen";
import RegisterScreen from "./screens/RegisterScreen";
import store from "./store/store";
import { Provider } from "react-redux";
import ProfileScreen from "./screens/ProfileScreen";
import PrivateRoute from "./components/PrivateRoute";
import ProgramsScreen from "./screens/ProgramsScreen";
import TemplatesScreen from "./screens/TemplatesScreen";
import PlaylistsScreen from "./screens/PlaylistsScreen";
import IdentsScreen from "./screens/IdentsScreen";
import SongsScreen from "./screens/Songs/SongsScreen";
import AddsPromosScreen from "./screens/AddsPromosScreen";
import ContactsScreen from "./screens/Songs/ContactsScreen";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      element={<App />}
    >
      <Route
        index={true}
        path="/"
        element={<HomeScreen />}
      />
      <Route
        path="/login"
        element={<LoginScreen />}
      />
      {/* only turn on this route if you need the register screen */}
      {/* <Route
        path="/register"
        element={<RegisterScreen />}
      /> */}
      {/* only turn on this route if you need the register screen */}
      <Route
        path=""
        element={<PrivateRoute />}
      >
        <Route
          path="/templates"
          element={<TemplatesScreen />}
        />
        <Route
          path="/playlists"
          element={<PlaylistsScreen />}
        />
        <Route
          path="/programs"
          element={<ProgramsScreen />}
        />
        <Route
          path="/profile"
          element={<ProfileScreen />}
        />
        <Route
          path="/register"
          element={<RegisterScreen />}
        />
        <Route
          path="/idents"
          element={<IdentsScreen />}
        />
        <Route
          path="/songs"
          element={<SongsScreen />}
        />
        <Route
          path="/addspromos"
          element={<AddsPromosScreen />}
        />
        <Route
          path="/songcontact"
          element={<ContactsScreen />}
        />
      </Route>
    </Route>
  )
);

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  </Provider>
);
